export enum COLORS {
  TREATMENT_REST_AT_HOME = '#4A536B',
  TREATMENT_ORAL = '#B8E0EC',
  TREATMENT_IV = '#FF9A8D'
}
